/**
 * 导航数据
 */
import Cookies from 'js-cookie';
import http from '@/utils/http';
const state = {
  version: 'v1.0.0',

  buildLogo: '/images/preloader/logo-build.png',
  // 建筑信息
  buildInfo: {
    buildId: '', // 建筑id
    buildName: '', // 建筑名
    map: '', // 地图id
    buildX: '', // 建筑原始坐标X
    buildY: '', // 建筑原始坐标Y
    provinceCode: '', // 省编码
    province: '', // 省
    cityCode: '', // 市编码
    city: '', // 市
    countyCode: '', // 区县编码
    county: '', // 区县
    buildAddr: '', // 详细地址
    createTime: '', // 创建时间
    createUserId: '', // 创建人ID
    lastTime: '', // 最后修改时间
    lastUserId: '', // 最后修改人ID
    remark: '', // 备注
    mapKey: '', // 地图key
    mapName: '', // 地图名称
    themeNo: '', // 地图主题
    initSize: '20', // 初始大小
    buildType: 1, // 建筑类型  1-医院  2-学校  3-企业   4-商场  5-车站  6-机场
    floorNameList: [], // 楼层名字映射
    damping: 0, // 环境因子
    mapPath: '', // 地图所在目录
    mapFileName: '', // 地图文件名
    buildVersion: 0, // 地图版本号
    defTheme: null, // 默认主题
  },
  // poi分类列表
  poiCategroyList: [],
  // 所有建筑节点
  allNodeList: [],
  // 所有poi列表
  allPoiList: [],
  // 起点
  startPoint: {
    name: '导诊台',
    floor: 1
  },
  // 终点
  endPoint: {
    name: '导诊台2',
    floor: 2
  },
  // 路径类型
  pathType: null,
  // 地图楼层ID集合
  mapFloorIdList: [],
  // 地图当前聚焦楼层
  mapFocusFloor: null,

  // 路径规划类型
  ROUTE_TYPE: {
    ESCALATOR_DOWN: 0, // 扶梯下
    ESCALATOR_UP: 1, // 扶梯上
    ELEVATOR: 2, // 电梯
    STAIRS: 3, // 楼梯
    STAFF: 4// 员工通道
  },
  // 节点类型到路径类型的映射关系
  NODE_TYPE_TO_ROUTE_TYPE_MAPING: {
    1: 2, 10: 1, 12: 0, 20: 3, 21: 3
  },
  // 当前选中的POI二维码
  curPoiQRcode: '',
  saverShow: false,
  saverData: {},
  initData: {},
  Timer: null,
  Timer2: null,
};

const getters = {
  // 地图楼层映射(楼层ID->楼层名字)，如：{1:'F1',2:'N1',3:'F3'}
  floorMapping (state) {
    let obj = {};
    let floorNameList = state.buildInfo.floorNameList || [];
    if (floorNameList.length > 0) {
      floorNameList.forEach((item, index) => {
        obj[index + 1] = item;
      });
    } else {
      state.mapFloorIdList.forEach(item => {
        obj[item] = item;
      });
    }
    return obj;
  },
  // 当前地图所有节点的集合，键值对形式（以nodeId为键值）
  allNodeObjById (state) {
    console.log(state.allNodeList, '1111111111111')
    if (!state.allNodeList) return {};
    let obj = {};
    state.allNodeList.forEach(item => {
      obj[item.nodeId] = item;
    });
    return obj;
  },
  // 当前地图所有POI的集合，键值对形式（以poiId为键值）
  allPoiObjById (state) {
    let obj = {};
    state.allPoiList.forEach(item => {
      obj[item.poiId] = item;
    });
    return obj;
  },
  // 当前地图所有节点的集合，按楼层划分 { x(floor): [...node] }
  allNodeFloorObj (state) {
    if (state.allNodeList) {
      let obj = {};
      state.mapFloorIdList.forEach(key => {
        obj[key] = [];
      });
      for (const key in obj) {
        state.allNodeList.forEach(item => {
          if (key === item.floor.toString()) {
            obj[key].push(item);
          }
        });
      }
      return obj;
    } else {
      return {};
    }
  },
  // 将POI按楼层划分 { floor: [...poi],... }
  allPoiFromFloor (state) {
    if (state.allPoiList) {
      let obj = {};
      state.mapFloorIdList.forEach(key => {
        obj[key] = [];
      });
      for (const key in obj) {
        state.allPoiList.forEach(item => {
          if (key === item.floor.toString()) {
            obj[key].push(item);
          }
        });
      }
      return obj;
    } else {
      return {};
    }
  }
};

const mutations = {
  set_buildLogo: (state, val) => {
    state.buildLogo = val;
  },
  set_buildInfo: (state, val) => {
    state.buildInfo = val;
  },
  set_mapFloorIdList: (state, val) => {
    state.mapFloorIdList = val;
  },
  set_mapFocusFloor: (state, val) => {
    state.mapFocusFloor = val;
  },
  set_startPoint: (state, val) => {
    state.startPoint = val;
  },
  set_endPoint: (state, val) => {
    state.endPoint = val;
  },
  set_pathType: (state, val) => {
    state.pathType = val;
  },
  set_curPoiQRcode: (state, val) => {
    state.curPoiQRcode = val;
  },
  set_saverShow: (state, val) => {
    state.saverShow = val;
  },
  set_saverData: (state, val) => {
    state.saverData = val;
  },
  set_initData: (state, val) => {
    state.initData = val;
  },
  set_poiCategroyList: (state, val) => {
    state.poiCategroyList = val;
  },
  set_allNodeList: (state, val) => {
    state.allNodeList = val;
  },
  set_allPoiList: (state, val) => {
    state.allPoiList = val;
  }
};

const actions = {
  // 进入屏保
  enterSaver ({ commit, state }, data) {
    if (state.saverData.protectTime && state.saverData.protectType > 0) {
      console.log('触发enterSaver');
      clearTimeout(state.Timer);
      state.saverShow = false;
      let time = sessionStorage.getItem('isInit') ? state.saverData.protectTime - state.initData.refreshTime : state.saverData.protectTime;
      state.Timer = setTimeout(() => {
        state.saverShow = true;
        sessionStorage.setItem('isInit', '');
      }, Number(time) * 1000);
    }
  },
  // 刷新进入初始哈
  enterInit ({ commit, state }, data) {
    if (state.initData.refreshTime) {
      console.log('触发enterInit');
      clearTimeout(state.Timer2);
      let timer = null;
      clearInterval(timer)
      state.Timer2 = setTimeout(() => {
        clearTimeout(state.Timer);
        sessionStorage.setItem('isInit', true);
        clearInterval(timer)
        let cookie_mac = Cookies.get('mac');
        timer = setInterval(() => {
          http.post('/proxy/api/cust/poiScreen/queryMac', { mac: cookie_mac }).then(res => {
            console.log('resresresresresres', res);
            if (res.code === 0 && res.data) {
              location.reload()
            }
          });
        }, 10000);
      }, Number(state.initData.refreshTime) * 1000);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
